import { Component, OnInit } from '@angular/core';
import { Unity } from '@core/model/unity.model';
import { UnityService } from '@app/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { UnityCreateComponent } from '@app/dashboard/unity/unity-create/unity-create.component';

@Component({
  selector: 'app-unity-list',
  templateUrl: './unity-list.component.html',
  styleUrls: ['./unity-list.component.css']
})
export class UnityListComponent implements OnInit {
  unitys: Unity[];
  modalOptios: NgbModalOptions;

  constructor(
    private unityService: UnityService,
    private modalService: NgbModal
  ) {
    this.modalOptios = {
      size: 'lg',
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
  }

  ngOnInit() {
    this.listUnitys();
  }

  listUnitys() {
    this.unityService.getAll().subscribe(
      data => {
        console.log(data);
        this.unitys = data;
      },
      error1 => console.log(error1)
    );
  }

  editModal(id: string) {
    const modal = this.modalService.open(
      UnityCreateComponent,
      this.modalOptios
    );
    modal.componentInstance.titulo = 'Editar Unidad';
    modal.componentInstance.estado = true;
    modal.componentInstance.unity_id = id;
    modal.result.then(resul => {
      if (resul) {
        this.listUnitys();
      }
    });
  }

  createUnity() {
    const modal = this.modalService.open(
      UnityCreateComponent,
      this.modalOptios
    );
    modal.componentInstance.titulo = 'Crear Unidad';
    modal.result.then(result => {
      // console.log(result);
      if (result) {
        this.listUnitys();
      }
    });
  }
}
